import { ICellRendererParams } from 'ag-grid-community';

export function AgNumberCellRenderer<TRow>({ data: row, colDef }: ICellRendererParams<TRow>) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const val = (row as any)[colDef?.field as any];

    if (typeof val === 'number') {
        return <>{val?.toLocaleString()}</>;
    }

    return <>{val}</>;
}
